"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicySelectInput = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var client_policies_1 = require("../../hooks/client-policies");
function PolicySelectInput(props) {
    var onChange = props.onChange, clientUuid = props.clientUuid;
    var _a = (0, client_policies_1.useClientPolicies)(clientUuid), data = _a.data, error = _a.error;
    var _b = (0, react_1.useState)('Loading policies...'), placeholderText = _b[0], setPlaceholderText = _b[1];
    var hasPriorPolicies = data && data.policies.length;
    var policyOptions = data && data.policies
        ? data.policies.map(function (policy) { return ({
            label: policy.linesOfCoverage[0].coverageType,
            value: policy.uuid,
        }); })
        : [];
    (0, react_1.useEffect)(function () {
        if (!data) {
            setPlaceholderText('Loading policies...');
        }
        else if (hasPriorPolicies) {
            setPlaceholderText('Select prior policy');
        }
        else {
            setPlaceholderText('No active policies');
        }
    }, [data]);
    return (react_1.default.createElement(core_ui_1.AdvancedSelectInput, { name: "priorPolicies", placeholder: placeholderText, onChange: function (selectedPolicy) {
            if (data) {
                onChange(data.policies.find(function (policy) { return policy.uuid === selectedPolicy; }));
            }
        }, options: policyOptions, isLoading: !data, disabled: !data || !hasPriorPolicies || !!error }));
}
exports.PolicySelectInput = PolicySelectInput;
